const staticKeysToDelete = [
  'categoryIds',
  'price.SAR.default',
  'categories.level1',
  'categories.level2',
  'categories.level3',
];

export function cleanFacetObject(obj) {
  return Object.entries(obj)?.reduce((acc, [key, value]) => {
    const isStaticKey = staticKeysToDelete?.includes(key);
    if (!isStaticKey) {
      acc[key] = value;
    }
    return acc;
  }, {});
}

export function transformObjectToList(input) {
  if (!input || Object.keys(input)?.length === 0) return [];

  const list = Object.entries(input)?.map(([attribute, values]) => ({
    title: attribute,
    attribute,
    list: Object.entries(values)?.map(([key, count]) => ({
      label: key,
      key,
      code: key,
      count,
    })),
  }));

  return list.sort((a, b) => {
    if (a.attribute === 'categories.level0') return -1;
    if (b.attribute === 'categories.level0') return 1;
    return 0;
  });
}

export function parseFiltersFromQuery(query) {
  const filters = query.filters;
  return filters ? filters.split(',') : [];
}

export const debouncePromise = (fn, time) => {
  let timer = undefined;

  return function debounced(...args) {
    if (timer) {
      clearTimeout(timer); // Clear the timeout first if it's already defined.
    }

    return new Promise((resolve) => {
      timer = setTimeout(() => resolve(fn(...args)), time);
    });
  };
};

const DEBOUNCE_MS = 200;
export const debounced = debouncePromise(
  (items) => Promise.resolve(items),
  DEBOUNCE_MS
);
